import React, { Component } from "react";
import SearchedDashboard from "./SearchedDashboard";
class SearchResultArea extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          padding: "4px 4px 8px 0",
          display: "flex"
        }}
      >
        <div
          style={{
            width: "100%",
            overflowY: "auto",
            paddingRight: 4
          }}
        >
          {this.props.data.map((d, index) => (
            <SearchedDashboard key={index} data={d} theme={this.props.theme}></SearchedDashboard>
          ))}
        </div>
      </div>
    );
  }
}

export default SearchResultArea;
